<template>
  <div style="padding-left: 10px;padding-right: 10px;min-width: 200px;max-width: 300px;max-height: 250px;overflow: auto">
    <div class="col-xs-12">
      <span>Filter by Categories</span>
    </div>
    <div class="col-xs-12" style="margin-top: 5px">
      <div class="row">
        <div class="col-xs-6">
          <a role="button" class="text-info"
             style="font-size: 12px;font-weight: normal;font-style: italic;" @click="feedFilter"> Select All</a>
        </div>
        <div class="col-xs-6 text-right">
          <a role="button" class="text-info"
             style="font-size: 12px;font-weight: normal;font-style: italic;" @click="clearFilter"> Clear All</a>
        </div>
      </div>
    </div>
    <div class="col-xs-12" style="margin-top: 5px">
      <div v-for="(category, key) in categories" :key="key" style="padding-top: 10px">
        <div class="checkbox checkbox-info checkbox-inline">
          <input :id="uniqId + 'checkbox-category-' + category.name" type="checkbox" v-on:change="categorySelected(category)"
                 v-bind:checked="checked(category)" :disabled="category.nb === 0">
          <label :for="uniqId + 'checkbox-category-' + category.name">
            <template v-if="!category.name">Undefined</template>
            <template v-else>{{category.name}}</template> ({{category.nb}})</label>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
  .pe-ul > li {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .pe-ul > li > i{
    color: #62cb31;
    font-weight: bold;
  }

  .pe-ul > li > span{
    font-size: 14px;
    font-weight: normal;
  }

</style>
<script>

export default {
  components: {},
  props: ['categories', 'categoriesSelected'],
  name: 'CategoryBox',
  data () {
    return {
      uniqId: ''
    }
  },
  methods: {
    checked: function (country) {
      if (this.categoriesSelected.length !== 0) {
        let tmpCategorySelected = this.categoriesSelected.find((categorySelected) => {
          return categorySelected.name === country.name
        })
        if (typeof tmpCategorySelected !== 'undefined') {
          return true
        }
      }
      return false
    },
    categorySelected: function (category) {
      let index = this.categoriesSelected.map((e) => {
        return e.name
      }).indexOf(category.name)

      if (index === -1) {
        this.categoriesSelected.push(category)
      } else {
        this.categoriesSelected.splice(index, 1)
      }
    },
    clearFilter: function (event) {
      this.categoriesSelected.splice(0, this.categoriesSelected.length)
      event.preventDefault()
    },
    feedFilter: function (event) {
      this.clearFilter(event)

      this.categories.forEach((category) => {
        this.categoriesSelected.push(category)
      })
      event.preventDefault()
    }
  },
  beforeMount () {
    this.uniqId = Math.random().toString()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/filter/CategoryBox.vue